import React from "react";
import {formatResultLabel} from "./InspectionReportFieldControl";

function getCellStatus(value, type) {
    if (value === undefined || value === null || value === "") {
        return "empty";
    }
    if (parseInt(type) === 1) {
        if (value == 0) return "ok";
        if (value == 1) return "ng";
        if (value == 2) return "unknown";
    }
    return "text";
}

const STATUS_LABEL = {
    empty: "미입력",
    ok: "정상",
    ng: "비정상",
    unknown: "미확인",
};

function InspectionReportOverviewCell({value, type}) {
    const isRadioType = parseInt(type, 10) === 1;
    const status = getCellStatus(value, type);

    /* 텍스트 항목 — 미입력 시 빈 칸, 입력 시 전체 텍스트 표시 (말줄임 없음) */
    if (!isRadioType) {
        if (status === "empty") {
            return <span className="ir-overview-cell ir-overview-cell--text-empty">&nbsp;</span>;
        }

        const rawLabel = formatResultLabel(value, type) || "";

        return (
            <span className="ir-overview-cell ir-overview-cell--text-only">
                <span className="ir-overview-cell__text">
                    {rawLabel.split("\n").map((line, i) => (
                        <React.Fragment key={i}>
                            {i > 0 && <br />}
                            {line}
                        </React.Fragment>
                    ))}
                </span>
            </span>
        );
    }

    const label = STATUS_LABEL[status];

    return (
        <span className={`ir-overview-cell ir-overview-cell--${status}`}>
            <span className="ir-overview-cell__dot" aria-hidden />
            <span className="ir-overview-cell__text">{label}</span>
        </span>
    );
}

function InspectionReportLegend({actions}) {
    const items = [
        {status: "empty", label: "미입력"},
        {status: "ok", label: "정상"},
        {status: "ng", label: "비정상"},
        {status: "unknown", label: "미확인"},
        {status: "text", label: "텍스트"},
    ];

    return (
        <div className="ir-legend-bar">
            <div className="ir-legend" aria-label="입력 상태 범례">
                {items.map(({status, label}) => (
                    <span key={status} className="ir-legend__item">
                        <span className={`ir-overview-cell__dot ir-overview-cell__dot--legend ir-overview-cell--${status}`} />
                        {label}
                    </span>
                ))}
            </div>
            {actions && <div className="ir-legend-bar__actions">{actions}</div>}
        </div>
    );
}

export {getCellStatus, InspectionReportOverviewCell, InspectionReportLegend};
